import PropTypes from 'prop-types';
import React from 'react';

import {
  Textarea,
  TextField,
  Label,
  Message,
} from '@zendeskgarden/react-textfields';

const TextArea = props => (
  <TextField>
    <Label>{props.label}</Label>
    <Textarea
      className="text__c-txt__input___2ZeOl"
      style={{ minHeight: 100 }}
      validation={props.validation ? 'error' : 'none'}
      id={props.id}
      onChange={props.onChange}
      value={props.value}
      resizable={props.resizable}
    />
    {props.validation && (
      <Message validation="error">{props.validation}</Message>
    )}
  </TextField>
);
TextArea.propTypes = {
  label: PropTypes.string.isRequired,
  validation: PropTypes.string,
  id: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.string,
  resizable: PropTypes.bool,
};

TextArea.defaultProps = {
  resizable: true,
};

export default TextArea;
